/**
 * Builds the trusted URL Stripe returns the customer to after a redirect-based
 * authentication step.
 *
 * Derived from the live document location rather than an environment value, so it
 * is always same-origin with the page that started the confirmation. Query string
 * and hash are dropped: Stripe appends its own result parameters to this URL.
 */
const getStripeReturnUrl = (): string => `${window.location.origin}${window.location.pathname}`;

export default getStripeReturnUrl;
